import { useState, useEffect, useRef } from 'react'
import { useFetch, useStorage } from 'hooks'
import { Icon } from 'assets/index'
import {
  Loading,
  UsersTable,
  DoclistHandle,
  Path,
  ShowDetails,
} from 'components/index'
import * as Sessions from 'components/Modal/Items'
import { IObject } from 'interfaces'
import ModalHeader from 'pages/Clientes/Components/ModalHeader'
import User from 'pages/Clientes/Components/User'
import { hasAccess, moneyToNumber } from 'helper/utils'
import { Container } from './style'
import AdicionaisContrato from '../AdicionaisContrato'

interface IProps {
  cur?: any
}

const statusOptions = [
  {
    label: 'Em negociação',
    value: 0,
  },
  {
    label: 'Contrato solicitado',
    value: 1,
  },
  {
    label: 'Contrato em criação',
    value: 2,
  },
  {
    label: 'Contrato em negociação',
    value: 3,
  },
  {
    label: 'Aguardando assinatura',
    value: 4,
  },
  {
    label: 'Contrato assinado',
    value: 5,
  },
  {
    label: 'Aguardando pagamento',
    value: 6,
  },
  {
    label: 'Pagamento realizado',
    value: 7,
  },
]

export default function Detalhes(props: IProps) {
  const { cur } = props
  const [loading, setLoading] = useState<boolean>(false)
  const [data, setData] = useState<any>({})
  const [user] = useStorage('User')
  const [showDetails, setShowDetails] = useState<boolean>(false)
  const api = useFetch(`/gestor/contract?id=${cur.id}`)
  const formdata = useRef<FormData>(new FormData())

  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await api.fetch('get')
      if (response.fail) throw new Error(response.errors.message)
      const info = response.data.data
      const { enterpriseId } = info.token
      info.documentList = []
      switch (info.token.holderList.length) {
        case 0:
          info.capType = 'Aberta'
          break
        case 1:
          info.capType = 'Personalizada Individual'
          break
        default:
          info.capType = 'Personalizada em Grupo'
      }
      info.account = await api
        .fetch('get', null, `/gestor/account?id=${info.accountId}`)
        .then((r) => r.data.data)

      info.enterprise = await api
        .fetch('get', null, `/gestor/enterprise?id=${enterpriseId}`)
        .then((r) => r.data.data)
      // // Fill documents
      // ;['contract', 'document'].forEach((type: string) => {
      //   ;['enterprise', 'contract'].forEach((source) => {
      //     info[source][`${type}List`]?.forEach((c: IObject) => {
      //       info.documentList.push({
      //         name: c.type,
      //         file: c.file,
      //         type,
      //       })
      //     })
      //   })
      // })
      info.attachment = { enterprise: [], contract: [] }
      // Enterprise
      ;['contract', 'enterprise'].forEach((s: string) => {
        ;['contract', 'document'].forEach((type: string) => {
          info[s][`${type}List`]?.forEach((c: IObject) => {
            info.attachment[s].push({
              name: c.type,
              file: c.file,
              type,
              status: c.status,
            })
          })
        })
      })

      info.token.contract = info.contract
      setData({ sourceId: cur.id, ...info })
      setLoading(false)
    } catch (err: any) {
      console.error('err', err)
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  const invested: any = moneyToNumber(data?.contract?.invested)

  if (loading) return <Loading modal />
  return (
    <Container>
      <ModalHeader
        backModal
        contractId={cur.id}
        user={data?.account?.user}
        title={data?.token?.name}
        type={data?.capType}
        subtitle="Detalhes da captação"
        status={data?.contract?.status}
        statusOptions={statusOptions}
        tokenGestorId={data?.token?.gestorId}
        gestorId={data?.account?.account?.gestorId}
      />

      <div>
        <ShowDetails
          onClick={() => setShowDetails((oldValue) => !oldValue)}
          hidden={!showDetails}
        />
        {showDetails ? <User accountData={data} readonly /> : null}
      </div>
      <Sessions.Info token={data?.token} />
      <Sessions.Condition
        setData={setData}
        contractId={cur.id}
        token={data?.token}
        contract={data?.contract}
        enterprise={data?.enterprise}
        noPix
      />
      <Sessions.Contract token={data?.token} contract={data?.contract} />
      <Sessions.Rental token={data?.token} />
      <Sessions.Dates
        edit={hasAccess('edit-dates-financial')}
        isInvesment={invested > 0}
        token={data.token}
        data={data}
        setData={setData}
        contractId={cur.id}
      />
      {data?.bonus && <Sessions.Bonus data={data?.bonus} />}
      <Sessions.Payments token={data?.token} />
      <Sessions.Simula
        id={data?.token?.id}
        name={data?.enterprise?.name}
        value={data?.token?.expected}
        isInsento={data?.token?.IRType === 'Isento'}
      />
      {data?.token?.holderList?.length > 1 && (
        <UsersTable
          captationID="id"
          data={data?.token?.holderList}
          disableDelete
        />
      )}
      <h4 className="detalhes-captacao-subtitle">Anexos do investimento</h4>
      <div className="detalhes-botoes-container">
        <DoclistHandle
          readonly={
            data?.contract?.status === 'Contrato Assinado' &&
            !hasAccess('wallet-add-documents')
          }
          documentList={data?.attachment?.contract}
          formdata={formdata.current}
          onChange={() => {
            api
              .fetch('put', formdata.current, `/gestor/contract?id=${cur.id}`, {
                'Content-type': 'multipart/form-data',
              })
              .then(console.log)
          }}
        />
      </div>
      <h4 className="detalhes-captacao-subtitle">Anexos da captação</h4>
      <div className="detalhes-botoes-container">
        <DoclistHandle
          documentList={data?.attachment?.enterprise}
          readonly
          formdata={formdata.current}
          onChange={() => {
            api
              .fetch('put', formdata.current, `/gestor/contract?id=${cur.id}`, {
                'Content-type': 'multipart/form-data',
              })
              .then(console.log)
          }}
        />
      </div>
      {hasAccess('migration') && <AdicionaisContrato data={data} />}
    </Container>
  )
}
